import { standaloneRuntimeIds, type RuntimeGraphIds } from '@/models/logic/RuntimeGraphIds';
import type { ILogicGraph } from '@/interfaces/models';
import { LogicGraph } from '@/models/logic/LogicGraph';

export class LogicGraphFactory {
  create(ids: RuntimeGraphIds = standaloneRuntimeIds): ILogicGraph {
    return new LogicGraph(ids);
  }
}
